import { render, staticRenderFns } from "./AccountFacebookSelect.vue?vue&type=template&id=33cf812c"
import script from "./AccountFacebookSelect.vue?vue&type=script&lang=js"
export * from "./AccountFacebookSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports